<template>
  <div class="main">
    <a @click="backLinkClicked()">{{ this.backLinkText }}</a>

    <Hunt
      :huntId="huntId"
      :huntStorePath="huntStorePath"
      :usersCacheStorePath="usersCacheStorePath" />
  </div>
</template>

<script>
import Hunt from "@/modules/hunts/Hunt.vue";

export default {
  name: "UserHunt",

  components: {
    Hunt
  },

  props: {
    huntStorePath: {
      type: String,
      required: true
    },

    huntId: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  methods: {
    backLinkClicked() {
      this.$router.go(-1);
    }
  },

  computed: {
    backLinkText() {
      return "<< Back";
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  overflow: auto;
}
</style>
